<template>
  <v-navigation-drawer app v-model="abrirNav" :color="cor" width="200">
	<v-list :color="cor">
		<v-list-item class="px-2">
			<v-list-item-avatar>
        <v-img height="50" :src="user.imagem"></v-img>
      </v-list-item-avatar>
    </v-list-item>

    <v-list-item link @click="abrirPerfil()">
      <v-list-item-content class="lighttext--text">
        <v-list-item-title class="title">{{user.dados.nome}}</v-list-item-title>
        <v-list-item-subtitle class="lighttext--text" >{{user.dados.email}}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>
   <v-divider></v-divider>
  <v-list nav dense :color="cor">
      <v-treeview item-disabled="locked" dense expand-icon="" activatable open-on-click :items="items" item-key="name" transition >
        <template slot="label" slot-scope="{ item }">
          <div @click="mudarPagina(item)">
            <v-icon class="lighttext--text mr-4">{{item.icon}}</v-icon>
            <h4 class="itemMenu" :class="{'marginChildren': item.idParent, 'itemMenuDesativado': item.locked }" >{{item.name}}</h4>
          </div>
        </template>
      </v-treeview>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
  import { mapState } from 'vuex'
  import ACESSOS from '@/Enums/Acessos.js'
	import metodos from '@/mixins/metodos'
  import Br from '@/config/barramento.js'

	export default{
		name: 'menuLateral',
    mixins: [metodos],
    computed: {
      ...mapState(['isMenuVisible' , 'user']),
      // subMargin(it){
      //   return "margin-left:" + it
      // }
    },
		data(){
			return{
        abrirNav: false,
        acessos: ACESSOS,
        menuAberto: false,
        cor: 'secondary',
        items: [
          {
            id: 1,
            locked: null,
            name: 'home',
            icon: 'mdi-home',
            link: '/'
            
          },
          {
            id: 2,
            name: 'Estudos',
            icon: 'mdi-school',
            children:[
              {id: 21, locked: null, icon: 'mdi-book-open-variant', name: 'textos', link: '/textos', idParent: 2},
              {id: 22, locked: null, icon: 'mdi-bookshelf', name: 'minhasPublicacoes', link: '/minhasPublicacoes', idParent: 2},
              {id: 23, locked: null, icon: 'mdi-television-play', name: 'cursos', link: '/cursos', idParent: 2}
            ]
          },
          {
            id: 3,
            locked: null,
            name: 'calendario',
            icon: 'mdi-calendar-range',
            link: '/calendario'
          },
          {
            id: 8,
            locked: null,
            name: 'Atendimentos',
            icon: 'mdi-hospital-box',
            children: [
              {id: 81, locked: null, icon: 'mdi-star', name: 'pessoas', link: 'pessoas', idParent: 8},
              {id: 82, locked: null, icon: 'mdi-form-select', name: 'fichas', link: 'fichasAtendimento', idParent: 8}
            ]
          },
          {
            id: 4,
            locked: null,
            name: 'iniciados',
            icon: 'mdi-account-group',
            link: '/iniciados'
          },
          {
            id: 5,
            locked: null,
            name: 'Cadastros',
            icon: 'mdi-file-multiple',
            children: [
              { id: 51, locked: null, icon: 'mdi-alarm-light-outline', name: 'avisos', link: 'cavisos', idParent: 5 },
              { id: 52, locked: null, icon: 'mdi-shape', name: 'categorias', link: 'ccategorias', idParent: 5 },
              { id: 53, locked: null, icon: 'mdi-alpha-c-circle', name: 'clas', link: 'cclas', idParent: 5 },
              { id: 54, locked: null, icon: 'mdi-map-marker', name: 'locais', link: 'clocais', idParent: 5 },
              { id: 55, locked: null, icon: 'mdi-ticket', name: 'tipoAtividades', link: 'ctipoatividades', idParent: 5 },
              { id: 56, locked: null, icon: 'mdi-list-status', name: 'status', link: 'cstatus', idParent: 5 },
              { id: 57, locked: null, icon: 'mdi-star', name: 'motivoAtendimento', link: 'motivoatendimento', idParent: 5},
              { id: 58, locked: null, icon: 'mdi-star', name: 'tipoAtendimento', link: 'tipoatendimento', idParent: 5},
              { id: 59, locked: null, icon: 'mdi-star', name: 'perfisAcessos', link: 'perfisAcessos', idParent: 5}
            ],
          },
          {
            id: 6,
            locked: null,
            name: 'adminPages',
            icon: 'mdi-desktop-classic',
            link: '/admin'
          },
          {
            id: 7,
            locked: null,
            name: 'preferencias',
            icon: 'mdi-cog',
            link: '/preferencias'
          }
        ],


			}
		},
		methods:{
			mudarPagina(item){

        if(item.link){
          this.$store.commit('setTitle', item.name)
          this.$router.push(item.link);
        }
        
      },
      abrirPerfil(){
        this.$store.commit('setTitle', 'Perfil')
        this.$router.push('/perfil')
      }
      
    },

    created(){
      
      Br.onNavOpen(() =>{
        this.abrirNav = true
      })

        this.items.forEach(v=>{

          let precisaAcesso = false
          for(let acesso in this.acessos){
            if(acesso == v.name.toUpperCase()){
              precisaAcesso = true
            }
          }
          if(precisaAcesso){
            v.locked = !this.verificaAcesso(this.acessos[v.name.toUpperCase()])
            if(v.children){
              v.children.forEach(c=>{
                c.locked = !this.verificaAcesso(this.acessos[c.name.toUpperCase()])
                
              })  
            }
          }else{
            if(v.children){
              v.children.forEach(c=>{
                c.locked = !this.verificaAcesso(this.acessos[c.name.toUpperCase()])
              })  
            }
          }
        })
      }
    

	}

</script>
	
<style scoped>

.itemMenu{
  cursor: pointer;
  color: white !important;
  display: inline;
  padding-left: -15px !important;
  font-weight: bold;
}

.itemMenuDesativado{
  font-weight: normal !important;
  color: rgba(255,255,255,0.5) !important;
}

.marginChildren{
  margin-left: 34px !important;
}

</style>